/* eslint-disable camelcase */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ObjectAttribute from '../../components/ObjectAttribute/ObjectAttribute';
import { useCallback } from 'react';

/**
 * @type import('../../components/ObjectAttribute/ObjectAttribute').ObjectAttributeShape[]
 */
const attributes = [{
  id: 1,
  label: "Multi Dropdown",
  code: "L6sZVEXytmTd",
  is_multiple: true,
  has_options: true,
  datatype: "string",
  ui_element: "dropdown",
  object_type_form_string: "user_offer",
  validation_expr: null,
  options: [{
    id: 1,
    label: "Littel, Anderson and Halvorson"
  }, {
    id: 2,
    label: "Toy-Bayer"
  }, {
    id: 3,
    label: "Nolan, Berge and Carter"
  }, {
    id: 4,
    label: "Mills-Keeling"
  }, {
    id: 5,
    label: "Raynor Inc"
  }, {
    id: 6,
    label: "Stamm Group"
  }, {
    id: 77,
    label: "Rosenbaum Group"
  }]
}, {
  id: 5,
  label: "Single dropdown",
  code: "L6sZVEXytmTad",
  is_multiple: false,
  has_options: true,
  datatype: "string",
  ui_element: "dropdown",
  object_type_form_string: "user_offer",
  validation_expr: null,
  options: [{
    id: 1,
    label: "Littel, Anderson and Halvorson"
  }, {
    id: 2,
    label: "Toy-Bayer"
  }, {
    id: 3,
    label: "Nolan, Berge and Carter"
  }, {
    id: 4,
    label: "Mills-Keeling"
  }, {
    id: 5,
    label: "Raynor Inc"
  }, {
    id: 6,
    label: "Stamm Group"
  }, {
    id: 77,
    label: "Rosenbaum Group"
  }]
}, {
  id: 2,
  label: "Checkbox 1",
  code: "WoLakKGwQVwW",
  is_multiple: false,
  has_options: false,
  datatype: "boolean",
  object_type_form_string: "user_offer",

  validation_expr: null,
  ui_element: "checkbox",
}, {
  id: 3,
  label: "Checkbox 2",
  code: "WoLakKGwQVwa",
  is_multiple: false,
  has_options: false,
  datatype: "boolean",
  object_type_form_string: "user_offer",

  validation_expr: null,
  ui_element: "checkbox"
}, {
  id: 4,
  label: "Text 1",
  code: "aTyFoLrKLb36",
  is_multiple: false,
  has_options: false,
  datatype: "string",
  object_type_form_string: "user_offer",

  validation_expr: null,
  ui_element: "text"
}, {
  id: 5,
  label: "Textarea",
  code: "WoLakKGwaVwW",
  is_multiple: false,
  has_options: false,
  datatype: "string",
  object_type_form_string: "user_offer",

  validation_expr: null,
  ui_element: "text_area"
}, {
  id: 6,
  label: "Date field",
  code: "WasdSaskSl",
  data_type: "string",
  object_type_form_string: "user_offer",
  ui_element: "date"
}, {
  id: 6,
  label: "Radio",
  code: "L6sZVEXyatmTd",
  datatype: "string",
  ui_element: "radio",
  object_type_form_string: "user_offer",
  validation_expr: null,
  options: [{
    id: 1,
    label: "Option 1"
  }, {
    id: 2,
    label: "Option 2"
  }, {
    id: 3,
    label: "Option 3"
  }]
}, {
  id: 7,
  label: "File input",
  code: "WoLakKGwQVwWa",
  is_multiple: false,
  has_options: false,
  datatype: "string",
  object_type_form_string: "user_offer",
  ui_element: "file_upload",
},{
  id: 8,
  label: "Link",
  code: "WoLakKGwQVwWb",
  datatype: "string",
  object_type_form_string: "user_offer",
  ui_element: "link"
}];

const ObjectAttributes = () => {

  const handleOnChange = useCallback((event) => {
    console.log(event.target.value);
    console.log(event.target.name);
  }, []);

  return (<div className="styles-section row" id="object-attributes">
    <Col sm={12} className='main-page-title'>
      <h3>Object Attributes</h3>
    </Col>

    <Col sm={12} className='home-page-content'>
      <Row className="align-items-start">

        {attributes.map(attr =>
          <Col sm={12} key={attr.code}>
            <ObjectAttribute fieldData={attr} onChange={handleOnChange} />
          </Col>
        )}

      </Row>
    </Col>
  </div>);
};

export default React.memo(ObjectAttributes);